module.exports = {
    load_more: 'LOAD MORE',
    version: 'versions',
    officeTime: '0900-2100',
    WechatText: 'Use wechat to scan the QR code to contact the account manager',
    bookOrder: {
        enterToast: 'The departure time or duration is not specified',
        agree: 'Please agree to the Terms of Service and Revocation policy',
        error: 'The end time must be before 12 PM',
        cancelTitle: 'Cancellation Policy',
        serviceTitle: 'Terms of Service and Conditions',
        termsTitle: 'Terms of Service and Conditions',
        policyTitle: 'Cancellation Policy',
    },
    order: {
        time: 'Please select your departure time',
        hour: 'Please select a duration',
        departure_time: 'DEPARTURE TIME',
    },
    loginForm: {
        verification_code: 'Please enter the verification code',
        loginSuccess: 'login successfully',
        phoneLoginTitle: 'MOBILE NUMBER LOGIN',
        emailLoginTitle: 'E-MAIL LOGIN',
    },
    month: {
        January: 'January',
        February: 'February',
        March: 'March',
        April: 'April',
        May: 'May',
        June: 'June',
        July: 'July',
        August: 'August',
        September: 'September',
        October: 'October',
        November: 'November',
        December: 'December',

        JANUARY: 'JANUARY',
        FEBRUARY: 'FEBRUARY',
        MARCH: 'MARCH',
        APRIL: 'APRIL',
        MAY: 'MAY',
        JUNE: 'JUNE',
        JULY: 'JULY',
        AUGUST: 'AUGUST',
        SEPTEMBER: 'SEPTEMBER',
        OCTOBER: 'OCTOBER',
        NOVEMBER: 'NOVEMBER',
        DECEMBER: 'DECEMBER',
    },
    sportSelectTime: 'Please select a date and time',
    selectMinRentTime: 'The minimum duration of the project is：',
    sportDate: 'DATE',
    noData: '"Temporarily no data"',
    ft: 'FT',
    upTo: 'UP TO',
    pax: 'PAX',
    form: {
        outDate: 'The current time has expired. Please select the correct time',
        success: 'success',
        fail: 'fail',
        h: 'hours',
        fail: 'fail',
        ok: 'OK',
        back: 'BACK',
        nameCheck: 'The user name is empty or contains more than 64 characters',
        phoneCheck: 'Area code + mobile phone number 6-20 digits',
        adultsCheck: 'The number of adults must be numeric and not blank',
        childrenCheck: 'The number of children must be numeric and not blank',
        endDateCheck: 'The end time cannot be empty',
        benginDate: 'The start time cannot be empty',
        dateCheck: 'The date cannot be empty',
        timeCheck: 'Travel time cannot be empty',
        hoursCheck: 'Time cannot be empty',
        qzCheck: 'The area code must be numeric and cannot be empty',
        emailCheck: 'The email format is incorrect',
        peoplesCheck: 'More people than the yacht can hold',
        maxPeople: 'Passengers exceed the maximum capacity',
        timeBar: 'The start time cannot exceed the end time',
        minTime: 'minimum time:',
        mustAdultCheck: 'There must be at least one adult',
        messageBoard: 'The message cannot be empty',
        countDown: 'count down',
    },
    // Quick Order
    quickyorderdeparture_point: 'DEPARTURE POINT',
    quickyorderyacht_length: 'YACHT LENGTH',
    quickyorderdeparture: 'DEPARTURE',
    quickyorderarrival: 'ARRIVAL',
    quickyorderduration: 'DURATION',
    quickyorderproples: 'ADULT/CHILDS',
    quickyordername: 'NAME',
    quickyorderphone: 'INTL CODE - MOBILE NUMBER',
    quickyorderemail: 'E-MAIL',
    quickyordertotal: 'TOTAL COST(inc 5% VAT)',
    quickyorderclose: 'CLOSE',
    quickyordercheckout: 'CHECKOUT',
    quickyordercancel: 'CLOSE',
    quickyorderok: 'OK',
    quickyorderPayTitle: 'WHETHER TO CONFIRM THE PAYMENT?',

    // home
    loginTitle: 'LOGIN TO YOUR ACCOUNT',
    verification_code: 'VERIFICATION CODE',
    get_verification_code: 'GET VERIFICATION CODE',
    me: 'MINE',
    login: 'LOGIN',
    news: 'NEWS',
    contact: 'CONTACT',
    team: 'TEAM',
    call: 'CALL US',
    contactUS: 'CONTACT US',
    wechat: 'Wechat',
    charter: 'YACHT CHARTER',
    super: 'SUPER YACHTS',
    waterSports: 'WATER SPORTS',
    fishing: 'FISHING',
    tours: 'YACHT TOURS',
    officeHours: 'OFFICE HOURS',
    officePhone: 'PHONE',
    email: 'EMAIL',
    marina: 'SKY WALKER YACHTS 1002 MARINA PLAZA, DUBAI MARINA, DUBAI',
    yachtRental: 'Sky Walker Yacht Rental 2022',
    services: 'SERVICES',
    help: 'HELP',
    aboutUs: 'ABOUT US',
    fqa: 'FAQ',
    main: 'MAINTENANCE',
    social: 'SOCIAL',
    partners: 'OUR PARTNERS',
    superYacht: 'SUPER YACHT ENQUIRY',
    yourName: 'YOUR NAME',
    intlCode: 'INTL CODE',
    mobileNum: 'MOBILE NUMBER',
    emails: 'E-MAIL',
    yacht: 'YACHT',
    adults: 'ADULTS',
    yacht: 'YACHT',
    tourDate: 'TOUR DATE',
    sendBtn: 'SEND ENQUIRY',
    nameRule: 'please enter your name',
    mobileRule: 'please enter your mobile',
    aboutus: 'About us',
    aboutUs_content:
        'Sky Walker Yachts entered the Dubai yacht charter market in March 2020. Offering a strong combination of western and eastern Leadership at the helm with over 25 years of worldwide charter experience.We commit to invest heavily into the Sky Walker team and fleet in order to champion an unparalleled consumer - focused approach.Our new vessel designs not only help renew industry standards but embrace sustainable advancements that move away from the use of fossil fuels to offer consumers a smoother,seamless and environmentally cleaner charter experience.',
    summer1: 'SUMMER OFFER',
    summer2: 'OFF',
    summer3: 'USE CODE ',
    yacht_filter: 'YACHT FILTER',
    select_date: 'Select Date',
    select_date_text: 'please select date',
    charter_hours: 'Charter Hours',
    charter_time: 'Charter Time',
    number_guests: 'Number of guests',
    gift_code: 'Gift Code',
    yachts_lists_title: 'FROM ONLY',
    yachts_lists_name: '',
    yachts_lists_book: 'BOOK',
    yachts_lists_instantly: 'INSTANTLY',
    yachts_lists_address: 'DEPARTURE',
    yachts_lists_capacity: 'CAPACITY',
    yachts_lists_crew: 'CREW',
    yachts_charter: 'All our charters include complimentary towels, snorkeling equipment, water, ice & soft drinks',
    yachts_charter_btn: 'CLICK HERE FOR MORE INFO',
    map_title: 'YACHT CRUISE MAP',
    map_position: 'DUBAI HARBOUR',
    map_hour1: '1 HOUR TOUR',
    map_hour2: '2 HOUR TOUR',
    map_hour3: '3 HOUR TOUR',
    map_address1: 'MARINA CANAL',
    map_address2: 'MARINA CANAL + BURJ AL ARAB',
    map_address3: 'MARINA CANAL + ATLANTIS + BURJ AL ARAB',
    walker_title: 'THE SKY WALKER EXPERIENCE',

    // super
    super_yachts: 'Super Yacht Charters',
    super_banner_text:
        'Sky Walker Super Yacht Charters opens the door to true luxury expected when in Dubai. We tailor all our charters to help you create exceptional moment and lifetime memories. When you charter with Sky Walker - Do so with confidence that all of the finer details have been convered!',
    super_nav_l: 'COMPLIMENTARY VIP PICK UP & DROP OFF',
    super_nav_r: 'Fine dining',
    super_nav_rs: 'ON BOARD WITH EXECUTIVE CHEFS',
    enquire: 'ENQUIRE NOW',
    super_tip_charter: 'CHARTER',
    super_tip_charter1: 'FROM /PER HOUR',
    super_tip_charter24: '24 HR RATE',
    build: 'BUILD',
    cabins: 'CABINS',
    berth: 'BERTH',
    sleeps: 'SLEEPS',
    startTime: 'START TIME',
    endTime: 'END TIME',
    super_detail1:
        'Yet again Sunseeker have created a flawless ship, the Notorious, which explains why it is an established and renowned name in the industry. The ship is built purely to express its lavishness and style. The ship offers a feeling of royalty, one you shouldn’t miss out on.  Once you get aboard the Notorious, you will find yourself being surrounded by flawless design, deluxe cabins, and the latest entertainment.',
    super_detail2:
        'Built by Numarine, this 105ft luxury yacht hire will surely offer a memorable sailing fun anywhere in the UAE. With an equally alluring and sporty design, high level of functionality and performance, Dolce Vita stands apart among the other party boat rental services. This luxury yacht charter is the perfect choice for private parties and corporate gatherings that require accommodation of up to 25 passengers at a time.',
    super_detail3:
        'The 35.2m/115’6” motor yacht ‘Legende’ by the British shipyard Sunseeker offers flexible accommodation for up to 10 guests in 5 cabins and features interior styling by British designer Sunseeker.',
    super_detail4:
        'Code8 164ft motor yacht was built by Benetti in 1995 and last refitted in 2016. Featuring a jacuzzi pool, lounge bar and a live BBQ station at the sky lounge, magnificent styling and lavish seating makes her ideal for a luxury yacht experience, corporate events, and team buildings. Accommodation incudes a master suite, three VIP staterooms and two twin cabins.',
    super_detail5:
        'A superstar experience on board a trackside yacht with a coveted viewing platform, this elite package includes 5* hospitality with a free-flowing Carbon Champagne bar and gourmet menus. Spectacularly located within the electric atmosphere of Yas Marina, the yacht offers sensational views over all the action on the south circuit. ',
    super_detail6:
        'A superstar experience on board a trackside yacht with a coveted viewing platform, this elite package includes 5* hospitality with a free-flowing Carbon Champagne bar and gourmet menus. Spectacularly located within the electric atmosphere of Yas Marina, the yacht offers sensational views over all the action on the south circuit. ',

    // water
    senior: 'Senior Instructor',
    senior_text:
        '"Our watersports cater for first timers to fanatics. So come, escape to the water and enjoy. All activities come with a driver and our own qualified instructors. Your Experience Is Our Passion!!"',
    senior_title: 'Surfs Up',
    cobalt: 'An expansive cockpit, spacious bow area, wrap-around seating with flexible convertibility, elongated port-side seating for the entire crew, and unmatched storage capacity. While these features alone make an excellent boat, the Cobalt R7 is also ranked #1 in ride comfort, giving it an unmatched combination of luxury and value – a few of the many reasons the R7 is consistently named the best bowrider on the water.',
    length: 'LENGTH',
    capacity: 'CAPACITY',
    berth: 'BERTH',
    dubai: 'DUBAI HARBOUR',

    knee_board: 'KNEE BOARD',
    wake_surf: 'WAKE SURF',
    wake_board: 'WAKE BOARD',
    jet_ski: 'JET SKI',
    knee: 'KNEE',
    boarding: 'BOARDING',
    wake: 'WAKE',
    surfing: 'SURFING',
    jet: 'JET',
    skiing: 'SKIING',
    surfing1: 'Minimum 3 HR session',
    surfing2: 'Open to riders of all abilities',
    surfing3: 'Instructor and diver on board',
    surfing4: 'All sports and safety',
    difficulty: 'DIFFICULTY',
    surf_btn: 'BOOK INSTANTLY',
    surf_question1: 'Do I need to bring equipment ?',
    surf_question2: 'Is wake surfing hard ?',
    surf_question3: 'It’s my first time. Will someone show me how to do it ?',
    surf_question4: 'I am a beginner at both. What should I start with ?',
    surf_question5: 'Is wake boarding better than wake surfing ?',
    surf_question6: 'What else is included ?',
    surf_question7: 'Can we bring cold snacks ?',
    surf_answer1: 'We have the wake/surf boards and liffe jackets,just let us know in advance your preferred activity.',
    surf_answer2: "If you find it hard,you'll still have a blast trying!",
    surf_answer3: 'A qualified instructor will be on the trip to guide you through the process.',
    surf_answer4: 'A tough one to answer,why not extend your time and try both to see what fits!',
    surf_answer5: 'Surfers like surfing.Boarders like boarding.What are you?',
    surf_answer6: 'We will provide all sporting and safety equipments in addition to soft drinks and water.',
    surf_answer7: 'Sure.',

    meet_post1: 'Senior Instructor',
    meet_text1:
        'An expansive cockpit, spacious bow area, wrap-around seating with flexible convertibility, elongated port-side seating for the entire crew, and unmatched storage capacity. While these features alone make',
    meet_post2: 'Senior Instructor',
    meet_text2:
        'An expansive cockpit, spacious bow area, wrap-around seating with flexible convertibility, elongated port-side seating for the entire crew, and unmatched storage capacity. While these features alone make',
    meet_post3: 'Senior Instructor',
    meet_text3:
        'An expansive cockpit, spacious bow area, wrap-around seating with flexible convertibility, elongated port-side seating for the entire crew, and unmatched storage capacity. While these features alone make',

    meetR_map: "FAQ'S",
    map_question: 'Ask us a question: ',
    what_do: 'WHAT DO OUR CUSTOMERS THINK OF US ?',
    what_do_title1: 'Best Wake spot in Dubai',
    what_do_title2: 'A big thank you',
    what_do_text1:
        'Great boats, wide selection of boards for riders of all levels:from beginners to pro.Nice team, veryhelpful drivers. New Dubai Harbour location is super convenient and easy accesible. You can pay witha card right on the boatvery smooth experience overall .',
    what_do_text2:
        'Thanks a million for a great experience.I had so much fun and it was so easy to stand on a board. I feel encouraged to take morelessons',
    now_add_fun: 'Now Add The Fun',
    fun_your: 'Your Charter',
    your_yacht_name: 'SAN LORENZO',

    crew: 'CREW',
    departure_date: 'DEPARTURE DATE',
    duration: 'DURATION',
    departure_point: 'DEPARTURE POINT',
    guest: 'GUESTS',
    on_board_catering: 'On Board Catering',
    boards_menus: 'MENUS',
    boards_details: 'DETAILS',
    boards_price: 'PRICE',
    boards_quantity: 'QUANTITY',
    sports_menus: 'WATER SPORTS',
    sports_unit: 'UNIT',
    sports_price: 'PRICE',
    sports_quantity: 'QUANTITY',
    toys_menus: 'YACHT TOYS',
    toys_unit: 'UNIT',
    toys_price: 'PRICE',
    toys_quantity: 'DESCRIBE',
    sport_title: 'Water Sports & Yacht Toys',
    booking_summary: 'Booking Summary',
    Name: 'NAME',
    Phone: 'PHONE',
    e_mail: 'E-MAIL',
    Guests: 'ADULT/CHILD',
    Hours: 'CHARTER HOURS',
    Date: 'DEPARTURE DATE',
    Location: 'LOCATION',
    charters: 'CHARTER',
    catering: 'CATERING',
    extras: 'EXTRAS',
    total: 'TOTAL ',
    total_inc: '(inc. 5% VAT)',
    agree: 'I have read & agree to the ',
    policy: 'I have read & agree to the ',
    policyrout: 'Cancellation Policy',
    secure_pay: 'Secure payment powered by',
    checkout: 'PROCEED TO CHECKOUT',
    agreerout: 'Terms of Service and Conditions',

    // coming
    Coming: 'Coming Soon',
    num_days: '{num} Days',

    // tours
    adult: 'Adult',
    child: 'Child',
    luxury_yacht_tours: 'Luxury Yacht Tours',
    luxury_yacht_tours_tip:
        'No need for huge budgets to hire a luxury Yacht to see the Arabian coastline. Now you can witness all the wonders of Dubai with family and friends and capture unforgettable memories that only dreams are made of',

    yacht_tours_operate_daily: 'YACHT TOURS OPERATE DAILY',
    live_virtual_tour: 'Live Virtual Tour',
    live_virtual_tour_under: 'powered by',
    book_instantly: 'BOOK INSTANTLY',
    yacht_code: 'HURRY! USE THE CODE <span>{code}</span> AT CHECKOUT FOR 20% OFF ON YOUR TRIP',
    yacht_tour_experience: 'YACHT TOUR EXPERIENCE',
    route_map: 'ROUTE MAP',
    tour_highlights: 'TOUR HIGHLIGHTS',
    faq: "FAQ'S",
    map_question: 'Ask us a question: ',

    tours_yacht_detail1: 'Includes: Tour guide, water, soft drinks, fresh fruit & freshly baked muffins',
    tours_yacht_detail2:
        'Includes: Tour guide, assorted sandwiches, chips, fresh fruit and freshly baked muffins, water & soft drinks',
    tours_yacht_detail3: 'Includes: Tour guide, assorted sandwiches, chips, fresh fruit & freshly baked muffins',
    tours_yacht_detail4: 'Includes: Tour guide, water & soft drinks',

    tour_question1: 'Where does the yacht depart from ?',
    tour_question2: 'Is swimming allowed ?',
    tour_question3: 'Is there a specific dress code ?',
    tour_question4: 'What time should we arrive on the day of the cruise ?',
    tour_question5: 'Can we wear shoes on board ?',
    tour_question6: 'What if I am late ?',
    tour_question7: 'What is the cancellation policy ?',
    tour_question8: 'Will there be options to stop the cruise for pictures ?',
    tour_question9: 'Can I bring in food & snacks ?',
    tour_question10: 'Can we bring our own alcohol ?',

    tour_answer1: 'We depart from Dubai Harbour.',
    tour_answer2: 'No.',
    tour_answer3: 'No,there is not.We suggest you wear something that suits the weather.',
    tour_answer4: 'Please arrive 20-30 mins before the departure time.',
    tour_answer5:
        'For the safety of the passengers and to keep the yacht in pristine conditions we require everyone to take their shoes off.',
    tour_answer6: 'The boat will depart at the departure time.No refunds will be provided.',
    tour_answer7:
        'Free cancellation upto 24 hours before departure.kindly note refunds can take up to 14 days to be reflected in your account.',
    tour_answer8:
        'The Captain will allow you to take pictures and entertain your requests without having to compromise on the cruise schedule.',
    tour_answer9:
        'Food and beverages will be served on board.The BBQ will include meat,chicken and vegetarian options with side salad dishes and bread.',
    tour_answer10: 'Alcohol is strictly prohibited on board.',

    march: 'March',
    april: 'April',
    may: 'May',
    read_more: 'Read more',
    news_events: 'News & Events',

    // company
    company_version: 'Company Vision',
    company_text:
        'Sky Walker Yachts, one of the most popular yacht charter companies in Dubai. At the best rates, we provide luxury yacht rental services on a daily and hourly basis. Every private or luxury yacht available for rent from Sky Walker Yachts, is owned entirely by us. We provide a professional boat rental service, backed by a competent yacht crew with adequate years of sailing experience. We aim to provide the finest yacht charter experience with security and unsurpassed elegance in Dubai through all of our services.',
    company_team_title1: 'The Office Team',
    company_team_title2: 'Captain & Crew',
    company_team_title3: 'Maintenance & Repair',
    teams_post1: 'Managing Director',
    teams_post2: 'Office Manager',
    teams_post3: 'Sales Manager',
    teams_post4: 'Assistant Manager - Operation',
    teams_post5: 'Assistant Manager - Maintenance',
    teams_post6: 'Sales Manager',
    teams_post7: 'B. D. Manager',
    teams_post8: 'H. R. Officer',
    teams_post9: 'Admin Officer',
    teams_post10: 'Digital Marketing Specialist',
    teams_post11: 'Graphic Designer',
    teams_post12: 'Accountant',
    teams_post13: 'Accountant',
    teams_post14: 'Accountant',
    teams_post15: 'B. D. Executive',
    teams_post16: 'Sales Executive',
    teams_post17: 'Sales Executive',
    teams_post18: 'Sales Executive',
    teams_post19: 'Sales Executive',
    teams_post20: 'Tourism Manager',
    teams_post21: 'Sales Executive',
    teams_post22: 'Sales Executive',
    teams_post23: 'Customer Service Representative',
    teams_post24: 'Jetty Coordinator',
    teams_post25: 'Front Desk Support',
    teams_post26: 'Company Driver',
    teams_post27: 'Company Driver',
    teams_post28: 'Company Driver',

    captain_post1: 'Yacht Captain',
    captain_post2: 'Yacht Captain',
    captain_post3: 'Yacht Captain',
    captain_post4: 'Yacht Captain',
    captain_post5: 'Yacht Captain',
    captain_post6: 'Yacht Captain',
    captain_post7: 'Yacht Captain',
    captain_post8: 'Yacht Captain',
    captain_post9: 'Yacht Captain',
    captain_post10: 'Yacht Captain',
    captain_post11: 'Yacht Steward',
    captain_post12: 'Yacht Steward',
    captain_post13: 'Yacht Steward',
    captain_post14: 'Yacht Steward',
    captain_post15: 'Motor Boat Instructor',
    captain_post16: 'Yacht Steward',
    captain_post17: 'Yacht Steward',
    captain_post18: 'Yacht Steward',
    captain_post19: 'Yacht Steward',
    captain_post20: 'Yacht Steward',
    captain_post21: 'Yacht Steward',
    captain_post22: 'Yacht Steward',
    captain_post23: 'Jet Ski Captain',
    captain_post24: 'Yacht Steward',
    captain_post25: 'Yacht Steward',
    captain_post26: 'Yacht Steward',
    captain_post27: 'Yacht Steward',
    captain_post28: 'Yacht Steward',
    captain_post29: 'Yacht Steward',
    captain_post30: 'Yacht Steward',
    captain_post31: 'Yacht Steward',
    captain_post32: 'Yacht Steward',
    captain_post33: 'Yacht Steward',
    repair_post1: 'Carpenter',
    repair_post2: 'The Engineer',
    repair_post3: 'Electrical Engineer',
    repair_post4: 'Painter',
    repair_post5: 'Electrical Engineer',
    repair_post6: 'The Engineer',
    repair_post7: 'Kitchen Helper',

    // water_booking
    water_title: 'WATER SPORTS BOOKING',
    your_name: 'YOUR NAME',
    intl_code: 'INTL CODE',
    mobile_number: 'MOBILE NUMBER',
    Adults: 'ADULTS',
    Childs: 'CHILDRENS',
    hour: 'HOURS',
    activity: 'ACTIVITY',
    total_cost: 'TOTAL COST (inc 5% VAT)',
    close: 'CLOSE',
    checkout_btn: 'CHECKOUT',
    // yachts_book
    yachts_book_title: 'STEP 1 OF 3',
    proceed: 'PROCEED',
    noData: '"Temporarily no data"',
    // tour_booking
    tour_booking_title: 'YACHT TOUR BOOKING',
    tour_date: 'TOUR DATE',
    tour_time: 'TOUR TIME',
    children: 'CHILDREN',
    infants: 'INFANTS (0-6)',

    //office
    office_title: 'SKY WALKER YACHTS OFFICE',
    office_form_label1: 'CONTACT FORM',
    office_form_label6: 'MESSAGE',
    office_form_btn: 'SEND ENQUIRY',
    office_contact_info: 'CONTACT INFORMATION',

    phone: 'PHONE',
    booking: 'BOOKING',
    booking_hotline: 'PHONE/BOOKING HOTLINE',
    sales_enquiry: 'SALES ENQUIRY',
    sales_enquiry: 'SALES ENQUIRY',
    marketing_enquiry: 'MARKETING ENQUIRY',
    career_opportunity: 'CAREER OPPORTUNITY',
    complaints: 'COMPLAINTS',
    feedback: 'FEEDBACK',
    office_address: 'OFFICE ADDRESS',
    location_pin: 'LOCATION PIN',
    office_hours: 'OFFICE HOURS',
    office_address_value: 'Sky Walker Yachts 1002 Marina Plaza Dubai Marina Dubai, U. A. E.',
    google_maps: 'GOOGLE MAPS',
    office_hours_value: '7 DAYS A WEEK',
    address: 'ADDRESS',
    directions: 'DIRECTIONS',
    contacts3_title: 'SKY WALKER YACHTS KIOSK',
    contacts3_address: 'Opposite Spinneys Marina Walk Dubai Marina Dubai, U. A. E. ',

    news_title1: 'F1 YACHT TRIP',
    news_desc1:
        'A superstar experience on board a trackside yacht with a coveted viewing platform, this elite package includes 5* hospitality with a free-flowing Carbon Champagne bar and gourmet menus. Spectacularly located within the electric atmosphere of Yas Marina, the yacht offers sensational views over all the action on the South circuit.',
    news_title2: 'SKY WALKER NYE CHARTER',
    news_desc2:
        'Experience New Years Eve in Dubai on a Private Yacht with free entry to the race. Charter a Yacht for New Years Eve. Choose your top level VIP Yacht. VIP Experience in Dubai. Premium Luxury Yachts. Private Yacht Charter.',
    news_title3: 'SKY WALKER FISHING TRIP',
    news_desc3:
        'Let an experienced skipper take you to prime fishing locations off Dubai—most of them tricky to find independently—on this small-group deep-sea fishing trip. Admire Dubai’s skyline as you cruise to the sites—guided by a fishfinder system—and use the supplied rods and bait to catch everything from barracuda to snapper.',

    news_right_desc:
        'Experience New Years Eve in Dubai on a Private Yacht with free entry to the race. Charter a Yacht for New Years Eve.',
    payType: {
        success: 'Payment successful!',
        fail: 'Payment failed!',
        ok: 'OK',
        back: 'BACK',
        again: 'PAY AGAIN',
    },
    headSeo: {
        superTitle: 'Super Yacht Rental Dubai - Bespoke Superyacht Charter Dubai - Sky Walker',
        superKey:
            'super yacht rental dubai,bespoke superyacht charter Dubai,custom yacht charter,superyacht charter dubai price,',
        superDec:
            'Bespoke Superyacht Charters can provide the experience of a private luxury yacht charter tailored to suit your needs and wants. Sky Walker custom luxury yacht charters.',
        shareTitle: 'Yacht Share Tours in Dubai,Dubai Marina Yacht Shared Tour',
        shareKey:
            'Yacht Share Tours in Dubai,shared yacht dubai,yacht share tour dubai,sharing yacht dubai,Dubai Marina Yacht Shared Tour',
        shareDec:
            "See Dubai's brightest sights from the water and meet like-minded people on this luxury shared tour.We offer pastries, juices or BBQ.Daily cruise timings from 8:30AM-7:30PM.",
        teachTitle: ' Best Water Sports In Dubai:Wake Boarding&surfing,Jet Ski Rental',
        teachKey:
            ' best water sports in dubai,wake Boarding dubai,wake surfing dubai,jet ski rental dubai,water sports dubai,water sports in dubai',
        teachDec:
            'Enjoy the best watersports in Dubai ,Jetski,wake Boarding,wake surfing,Waterskiing,luxury yacht tour,wave boat and much more,Open every day.We offer best prices, great towboats, best service.',
        fishTitle: 'Dubai Fishing Clubs  | Fishing Charter Dubai - Sky Walker',
        fishKey:
            'fishing clubs dubai, fishing charter dubai, fishing in dubai, bass fishing clubs, fishing in the uae, deep sea fishing dubai, fishing spots in dubai, fishing tours dubai, fishing trips dubai',
        fishDec:
            'There are different styles of fishing and each one uses a different type of equipment and fishing clubs in Dubai will help you learn everything you need to catch a fish. View all Fishing Clubs with details at Sky Walker.',
        teamTitle: "Dubai's favourite yacht charter company - Sky Walker",
        teamKey: "Dubai's favourite yacht charter company,The most popular yacht charter company in Dubai",
        teamDec:
            'Skywalker Yachts is one of the most popular yacht charter companies in Dubai. We offer the best rates and luxury yacht charter services on a daily and hourly basis.',
        newsTitle: 'Yacht charter Dubai news and events',
        newsKey: 'yacht charter dubai news, yacht rental dubai news, yacht events dubai',
        newsDec:
            'Check out the latest news and events at Sky Walker. With our own diving school, boat club, private and group tours, there is something for everyone.',
    },
}
